import { AspectRatio } from '@/components/ui/aspect-ratio';
import { motion } from 'framer-motion';

const AutoLaunchSection = () => {
  return (
    <section id="auto-launch" className="section relative py-24 overflow-hidden">
      {/* Background gradient effect */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-blue-900/10 to-transparent" />
      
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="max-w-6xl mx-auto px-4 sm:px-6 relative"
      >
        {/* Section badge */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="flex justify-center mb-4"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-blue-500/10 to-cyan-500/10 backdrop-blur-sm border border-blue-500/20">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-gradient-to-r from-blue-500 to-cyan-500"></span>
            </span>
            <span className="text-sm font-medium bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
              24/7 Automation
            </span>
          </div>
        </motion.div>
        
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          viewport={{ once: true }}
          className="text-4xl md:text-5xl font-bold text-center mb-6"
        >
          <span className="text-white">Auto Launch Markets You</span>{' '}
          <span className="bg-gradient-to-r from-blue-400 via-cyan-400 to-teal-400 bg-clip-text text-transparent animate-gradient-x">
            24/7/365
          </span>
        </motion.h2>
        
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          viewport={{ once: true }}
          className="text-xl text-gray-300 text-center mb-12 max-w-3xl mx-auto leading-relaxed"
        >
          Munger AI Auto Launch uses your targeting & USP then{' '}
          <span className="text-white font-medium">creates, adds new messaging and improves campaigns</span>{' '}
          on its own.
        </motion.p>
        
        <motion.div 
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
          className="relative w-full max-w-4xl mx-auto"
        >
          {/* Glow effect behind video */}
          <div className="absolute -inset-4 bg-gradient-to-r from-blue-500/20 via-cyan-500/20 to-teal-500/20 blur-3xl opacity-70" />
          
          {/* Glass morphism card */}
          <div className="relative backdrop-blur-sm bg-gradient-to-br from-gray-800/40 to-gray-900/40 rounded-2xl border border-gray-700/50 p-1 shadow-2xl">
            <div className="bg-gradient-to-br from-gray-900/80 to-gray-950/80 rounded-xl overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-tr from-blue-500/5 to-cyan-500/5" />
              <AspectRatio ratio={16/9} className="w-full relative">
                <iframe 
                  src="https://player.vimeo.com/video/1069179803?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479"
                  width="100%" 
                  height="100%" 
                  frameBorder="0" 
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                  title="Campaign Launch feature"
                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                />
              </AspectRatio>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default AutoLaunchSection;
